import React, { useMemo } from 'react';
import { Configure } from 'react-instantsearch-dom';

import { SAVED_EVENTS_QUERY } from '@general/graphql/event.graph';
import { mapSearchEventToPropsNew } from '@general/transforms/event.transform';
import useViewerEvents from '@hooks/useViewerEvents';
import EventListItemTrustee from '@molecules/EventListItemTrustee';
import LoadingArea from '@molecules/LoadingArea';
import SearchStatsInfinite from '@react/components/search/SearchStatsInfinite';
import SearchContainer from '@search/SearchContainer';
import SearchInfiniteHits from '@search/SearchInfiniteHits';
import useEventsPastFilters from '../../../hooks/algoliaFilters/useEventsPastFilters';

const PAGE_SIZE = 6;

const EventListItem = props => {
    return <EventListItemTrustee {...props} showBottomLinkCheck={() => false} showFavoriteIcon={false} />;
};

const SearchEventsTrusteePast = () => {
    const { data: viewerEvents } = useViewerEvents();
    const { filters: eventsPastFilters } = useEventsPastFilters();
    const filters = useMemo(() => {
        if (!eventsPastFilters || !viewerEvents) {
            return null;
        }

        return `trustee_event = 1 AND ${eventsPastFilters} AND (${viewerEvents
            .map(event => `event_code:${event.code}`)
            .join(' OR ')})`;
    }, [eventsPastFilters, viewerEvents]);

    if (!filters) {
        return <LoadingArea />;
    }

    return (
        <SearchContainer index="events_meeting_start_time_desc">
            <Configure clickAnalytics filters={filters} hitsPerPage={PAGE_SIZE} />

            <div className="mb-1rem">
                <SearchStatsInfinite pageSize={PAGE_SIZE} />
            </div>

            <SearchInfiniteHits
                HitComponent={EventListItem}
                NoResultsText={() => <>Looks like you have no past trustee events.</>}
                favoritesProp="viewerEvents"
                favoritesQuery={SAVED_EVENTS_QUERY}
                index="events_meeting_start_time_asc"
                resultsPerRow={1}
                searchType="events"
                transformFunc={mapSearchEventToPropsNew}
            />
        </SearchContainer>
    );
};

export default SearchEventsTrusteePast;
